import React, { Children, useCallback, useMemo } from "react";
import { StyleSheet, View, Text } from "@react-pdf/renderer";
import generalStyle from "../../styles";

export const Table = ({
  headers,
  children,
  themeData,
  rowHighlight = false,
}) => {
  const tableBlock = StyleSheet.create({
    table: {
      marginTop: 15,
      borderStyle: "solid",
      borderWidth: 1,
      borderColor: themeData.tableBorder,
    },
    headerContainer: {
      ...generalStyle.inLineBlocks,
      padding: 9,
    },
    tableHeaderText: {
      ...generalStyle.bold,
      fontSize: 10,
    },
    tableRowpair: {
      padding: 9,
      flexDirection: "row",
      backgroundColor: themeData.tableRowsBackgroundColor,
    },
    tableRowOdd: {
      padding: 9,
      flexDirection: "row",
    },
  });

  const setRowColor = (index, highlight) => {
    if (rowHighlight) {
      return highlight ? tableBlock.tableRowpair : tableBlock.tableRowOdd;
    }
    return index % 2 === 0 ? tableBlock.tableRowpair : tableBlock.tableRowOdd;
  };

  return (
    <View data-testid="report-table" style={tableBlock.table}>
      {/* TableHeader */}
      {
        <View style={tableBlock.headerContainer}>
          {headers.map((header, index) => (
            <View
              key={`header-${index}`}
              style={{
                width: header.width,
                textAlign: header.textAlign,
              }}
            >
              <Text style={tableBlock.tableHeaderText}>{header.value}</Text>
            </View>
          ))}
        </View>
      }

      {/* TableContent */}
      {Children.map(children, (child, index) => {
        return (
          <View
            key={`content-${index}`}
            style={setRowColor(index, child?.props?.highlight)}
          >
            {Children.map(child.props.children, (subChild, subIndex) => {
              return (
                <View
                  key={`cell-${subIndex}`}
                  style={{
                    width: headers[subIndex].width,
                    textAlign: headers[subIndex].textAlign,
                  }}
                >
                  <View style={subIndex !== 0 && { textAlign: "right" }}>
                    {subChild}
                  </View>
                </View>
              );
            })}
          </View>
        );
      })}
    </View>
  );
};
